import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentFieldConfirmationFailedAction = {
	type: 'DOCUMENT_FIELD_CONFIRMATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentFieldConfirmationFailedAction => ({
	type: 'DOCUMENT_FIELD_CONFIRMATION_FAILED',
	payload,
});
